import { Button, Container, Link, Stack, Typography } from '@mui/material';
import { ReactNode } from 'react';

type Error404Props = {
  message?: ReactNode;
};

const DEFAULT_ERROR_MESSAGE =
  'Page not found, please check the URL/link you used.';

const Error404 = ({ message = DEFAULT_ERROR_MESSAGE }: Error404Props) => (
  <Container>
    <Stack
      height="100vh"
      textAlign="center"
      alignItems="center"
      justifyContent="center"
      spacing={3}
      mt={-8}
    >
      <Typography variant="h2">404!</Typography>
      <Typography variant="body1" color="text.secondary">
        {message}
      </Typography>
      <Button
        variant="contained"
        LinkComponent={Link}
        href="/"
        sx={{
          '&:hover': {
            color: 'primary.contrastText',
          },
        }}
      >
        Go Home
      </Button>
    </Stack>
  </Container>
);

export default Error404;
